<p-table [scrollable]="true" [size]="'small'" [value]="timesheets()" scrollHeight="flex" stripedRows>
  <ng-template #header>
    <tr>
      <th pResizableColumn pSortableColumn="subject" style="width: 22%">{{ 'timesheet.subject' | translate }}
        <p-sortIcon field="subject"/>
      </th>
      <th pResizableColumn pSortableColumn="date" style="width: 120px">{{ 'timesheet.date' | translate }}
        <p-sortIcon field="date"/>
      </th>
      <th pResizableColumn style="width: 120px">{{ 'timesheet.start' | translate }}

      </th>
      <th pResizableColumn style="width: 120px">{{ 'timesheet.end' | translate }}

      </th>
      <th pResizableColumn
          style="width: 120px">{{ 'timesheet.duration' | translate }}

      </th>
      <th pResizableColumn pSortableColumn="timesheetType.name">{{ 'timesheet.type' | translate }}
        <p-sortIcon field="timesheetType.name"/>
      </th>
      <th pResizableColumn style="width: 160px">{{ 'entity.activity-types' | translate }}</th>
      <th pResizableColumn pSortableColumn="status.name"
          style="width: 120px">{{ 'timesheet.status' | translate }}
        <p-sortIcon field="status.name"/>
      </th>
      <th pResizableColumn pSortableColumn="concern.fullName" style="width: 22%">{{ 'entity.customer' | translate }}
        <p-sortIcon field="concern.fullName"/>
      </th>
      <th pResizableColumn pSortableColumn="createdBy.fullName"
          style="width: 130px">{{ 'timesheet.created-by' | translate }}
        <p-sortIcon field="createdBy.fullName"/>
      </th>
      <th pResizableColumn pSortableColumn="billingTimesheetState"
          style="width: 120px">{{ 'timesheet.state' | translate }}
        <p-sortIcon field="billingTimesheetState"/>
      </th>
      <th style="width: 100px"></th>
    </tr>
  </ng-template>
  <ng-template #body let-timesheet>
    <tr (click)="onRowSelect(timesheet)" class="cursor-pointer hover:bg-gray-50">
      <td>
        <div class="flex items-center gap-2">
          @if (timesheet.isBillable) {
            <elcia-icon iconSize="sm" iconType="finances"/>
          }
          <span>{{ timesheet.subject }}</span>
        </div>
      </td>
      <td>{{ timesheet.date | date: 'dd/MM/yyyy' }}</td>
      <td>{{ timesheet.startTime | date:'HH:mm' }}</td>
      <td>{{ timesheet.endTime | date:'HH:mm' }}</td>
      <td>{{ timesheet.durationInSeconds | duration }}</td>
      <td>{{ timesheet.timesheetType.name }}</td>
      <td>
        <div class="flex flex-wrap gap-1">
          @for (activityType of timesheet.activityTypes; track activityType.id) {
            <elcia-badge>{{ activityType.name }}</elcia-badge>
          }
        </div>
      </td>
      <td>
        @if (timesheet.status) {
          <div class="flex items-center gap-2">
            <elcia-dot [color]="timesheet.status.color"/>
            <span>{{ timesheet.status.name }}</span>
          </div>
        }
      </td>
      <td>{{ timesheet.concern?.fullName }}</td>
      <td>
        <elcia-avatar [avatars]="timesheet.createdBy ? [timesheet.createdBy] : []" [maxItem]="1"/>
      </td>
      <td>
        <elcia-timesheet-state-badge [state]="timesheet.billingTimesheetState"/>
      </td>
      <td class="flex justify-end gap-1">
        @if (canValidate()) {
          @if (timesheet.billingTimesheetState === BillingTimesheetState.DRAFT && timesheet.isBillable) {
            <elcia-button (onClick)="changeState($event, timesheet, BillingTimesheetState.VALID)"
                          [icon]="'check'" [severity]="'success'" [variant]="'text'"/>
          } @else if (timesheet.billingTimesheetState === BillingTimesheetState.VALID) {
            <elcia-button (onClick)="changeState($event, timesheet, BillingTimesheetState.DRAFT)"
                          [icon]="'minus'" [severity]="'secondary'" [variant]="'text'"/>
          }
        }
        <elcia-button (onClick)="duplicate($event, timesheet)" [icon]="'clone'"
                      [tooltip]="'action.duplicate' | translate"
                      [variant]="'text'" ]/>
        <elcia-button (onClick)="delete($event, timesheet)" [icon]="'delete'" [severity]="'danger'"
                      [tooltip]="'action.delete' | translate" [variant]="'text'"/>
      </td>
    </tr>
  </ng-template>
  <ng-template #footer>
    <tr class="font-semibold">
      <td class="text-right" colspan="4">{{ 'timesheet.total' | translate }}</td>
      <td>{{ totalDuration() | duration }}</td>
      <td colspan="7"></td>
    </tr>
  </ng-template>
</p-table>
